import { DialogContent } from '@mui/material';
import { Deck, TextInput, Text } from '@legacy/components/ui-components';

export default () => (
  <DialogContent>
    <Deck data-automation-id="PageActionModalMileageRegistration">
      This is Mileage Registration
    </Deck>
    <Text data-automation-id="LabelName">Name</Text>
    <TextInput data-automation-id="TextBoxName" label="Name" name="Name" />
  </DialogContent>
);
